import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Instagram, Facebook } from "lucide-react";
import Logo from "@/components/Logo";

const Footer = () => {
  return (
    <footer className="bg-obsidian-light border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <Logo size="md" linkToHome={true} />
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              Minneapolis' new home for real musicians and real music lovers. 
              Where the music breathes.
            </p>
            <div className="flex gap-4">
              <a href="https://www.instagram.com/brownstonejazzmn/" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-electric transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/share/17yZAxAMKC/" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-electric transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-lg text-white mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/events" className="text-white/60 hover:text-electric text-sm transition-colors">
                  Upcoming Events
                </Link>
              </li>
              <li>
                
                <Link to="/private-events" className="text-white/60 hover:text-electric text-sm transition-colors">
                  Private Events
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/60 hover:text-electric text-sm transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-display text-lg text-white mb-4">Visit Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-electric mt-0.5 flex-shrink-0" />
                <span className="text-white/60 text-sm">
                  2756 Hennepin Ave<br />
                  Minneapolis, MN 55408
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-electric flex-shrink-0" />
                <span className="text-white/60 text-sm">info@brownstonejazzclub.com</span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-display text-lg text-white mb-4">Hours</h4>
            <p className="text-white/60 text-sm mb-2">
              Open during scheduled shows only
            </p>
            <p className="text-white/50 text-sm">
              Check our events calendar for upcoming performances
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-xs">
            © 2026 The BrownStone Jazz Club. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs">
            <a href="#" className="text-white/40 hover:text-white/60 transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-white/40 hover:text-white/60 transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
